// Banner Carousel
document.addEventListener('DOMContentLoaded', function() {
  const bannerCarousel = document.querySelector('.js-banner-carousel');
  if (!bannerCarousel) return;

  const carouselInner = bannerCarousel.querySelector('.inner');
  const carouselItems = bannerCarousel.querySelectorAll('.product__banner-carousel__item');
  
  // アイテムが1つ以下の場合はカルーセル不要
  if (carouselItems.length <= 1) return;

  // 無限ループのため、最初と最後の要素を複製
  const firstItemClone = carouselItems[0].cloneNode(true);
  const lastItemClone = carouselItems[carouselItems.length - 1].cloneNode(true);
  
  carouselInner.insertBefore(lastItemClone, carouselItems[0]);
  carouselInner.appendChild(firstItemClone);

  // 複製後の全アイテムを取得
  const allItems = carouselInner.querySelectorAll('.product__banner-carousel__item');
  const totalItems = allItems.length;
  const originalItemCount = carouselItems.length; // 実要素の数
  const transitionDuration = 500; // CSS transition時間（ミリ秒）

  let currentIndex = 1; // 最初の実要素から開始（インデックス1 = 最後の複製の次）
  let intervalId = null;
  const autoScrollInterval = 3000; // 3秒間隔

  // ドットインジケーターを生成
  const dotsContainer = bannerCarousel.querySelector('.js-banner-carousel-dots');
  const dots = [];
  
  for (let i = 0; i < originalItemCount; i++) {
    const dot = document.createElement('span');
    dot.className = 'product__banner-carousel__dot';
    if (i === 0) {
      dot.classList.add('is-active');
    }
    dotsContainer.appendChild(dot);
    dots.push(dot);
  }

  // 現在の実要素インデックスを取得（複製を考慮）
  function getRealIndex(index) {
    if (index === 0) {
      return originalItemCount - 1; // 最初の複製要素は最後の実要素
    } else if (index >= totalItems - 1) {
      return 0; // 最後の複製要素は最初の実要素
    } else {
      return index - 1; // 実要素のインデックス
    }
  }

  // ドットのアクティブ状態を更新
  function updateDots(index) {
    const realIndex = getRealIndex(index);
    dots.forEach(function(dot, i) {
      if (i === realIndex) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }

  // 現在のアイテムにスクロールする関数
  function scrollToIndex(index, useTransition = true) {
    const itemWidth = allItems[0].offsetWidth;
    const translateX = -index * itemWidth;
    
    if (useTransition) {
      carouselInner.style.transition = 'transform 0.5s ease-in-out';
    } else {
      carouselInner.style.transition = 'none';
    }
    
    carouselInner.style.transform = `translateX(${translateX}px)`;
    currentIndex = index;
    updateDots(index);
  }

  // 前のアイテムに移動
  function goToPrevious() {
    currentIndex--;
    
    // 最初の複製要素（最後の要素の複製）に到達したら、アニメーションなしで最後の実要素にリセット
    if (currentIndex <= 0) {
      scrollToIndex(0); // 最初の複製要素まで移動
      
      // アニメーション完了後にリセット
      setTimeout(function() {
        scrollToIndex(totalItems - 2, false); // アニメーションなしで最後の実要素に戻る
      }, transitionDuration);
    } else {
      scrollToIndex(currentIndex);
    }
  }

  // 次のアイテムに移動
  function goToNext() {
    currentIndex++;
    
    // 最後の複製要素（最初の要素の複製）に到達したら、アニメーションなしで最初の実要素にリセット
    if (currentIndex >= totalItems - 1) {
      scrollToIndex(currentIndex); // 最後の複製要素まで移動
      
      // アニメーション完了後にリセット
      setTimeout(function() {
        scrollToIndex(1, false); // アニメーションなしで最初の実要素に戻る
      }, transitionDuration);
    } else {
      scrollToIndex(currentIndex);
    }
  }

  // 自動スクロールを開始
  function startAutoScroll() {
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(goToNext, autoScrollInterval);
  }

  // 自動スクロールを停止
  function stopAutoScroll() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  // スワイプ機能の変数
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let touchEndY = 0;
  let isDragging = false;
  let dragStartX = 0;
  let dragOffset = 0;
  const swipeThreshold = 50; // スワイプ判定の最小距離（ピクセル）

  // タッチ開始
  function handleTouchStart(e) {
    stopAutoScroll();
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    isDragging = true;
    dragStartX = touchStartX;
    dragOffset = 0;
    carouselInner.style.transition = 'none';
  }

  // タッチ移動
  function handleTouchMove(e) {
    if (!isDragging) return;
    
    const touchX = e.touches[0].clientX;
    const touchY = e.touches[0].clientY;
    dragOffset = touchX - dragStartX;
    
    const itemWidth = allItems[0].offsetWidth;
    const baseTranslateX = -currentIndex * itemWidth;
    const translateX = baseTranslateX + dragOffset;
    
    carouselInner.style.transform = `translateX(${translateX}px)`;
  }

  // タッチ終了
  function handleTouchEnd(e) {
    if (!isDragging) return;
    
    touchEndX = e.changedTouches[0].clientX;
    touchEndY = e.changedTouches[0].clientY;
    
    const deltaX = touchEndX - touchStartX;
    const deltaY = touchEndY - touchStartY;
    const absDeltaX = Math.abs(deltaX);
    const absDeltaY = Math.abs(deltaY);
    
    // 横方向のスワイプが縦方向より大きい場合のみ処理
    if (absDeltaX > absDeltaY && absDeltaX > swipeThreshold) {
      if (deltaX > 0) {
        // 右にスワイプ（前の画像）
        goToPrevious();
      } else {
        // 左にスワイプ（次の画像）
        goToNext();
      }
    } else {
      // スワイプ距離が足りない場合は元の位置に戻す
      scrollToIndex(currentIndex);
    }
    
    isDragging = false;
    carouselInner.style.transition = 'transform 0.5s ease-in-out';
    
    // 自動スクロールを再開（少し遅延させて操作感を向上）
    setTimeout(function() {
      startAutoScroll();
    }, 1000);
  }

  // マウスドラッグ（デスクトップ対応）
  function handleMouseDown(e) {
    stopAutoScroll();
    dragStartX = e.clientX;
    isDragging = true;
    dragOffset = 0;
    carouselInner.style.transition = 'none';
    e.preventDefault();
  }

  function handleMouseMove(e) {
    if (!isDragging) return;
    
    dragOffset = e.clientX - dragStartX;
    
    const itemWidth = allItems[0].offsetWidth;
    const baseTranslateX = -currentIndex * itemWidth;
    const translateX = baseTranslateX + dragOffset;
    
    carouselInner.style.transform = `translateX(${translateX}px)`;
  }

  function handleMouseUp(e) {
    if (!isDragging) return;
    
    const absDragOffset = Math.abs(dragOffset);
    
    if (absDragOffset > swipeThreshold) {
      if (dragOffset > 0) {
        // 右にドラッグ（前の画像）
        goToPrevious();
      } else {
        // 左にドラッグ（次の画像）
        goToNext();
      }
    } else {
      // ドラッグ距離が足りない場合は元の位置に戻す
      scrollToIndex(currentIndex);
    }
    
    isDragging = false;
    carouselInner.style.transition = 'transform 0.5s ease-in-out';
    
    // 自動スクロールを再開
    setTimeout(function() {
      startAutoScroll();
    }, 1000);
  }

  // 初期位置を設定（最初の実要素の位置）
  scrollToIndex(1, false);

  // タッチイベントリスナー
  bannerCarousel.addEventListener('touchstart', handleTouchStart, { passive: true });
  bannerCarousel.addEventListener('touchmove', handleTouchMove, { passive: true });
  bannerCarousel.addEventListener('touchend', handleTouchEnd, { passive: true });

  // マウスイベントリスナー（デスクトップ対応）
  bannerCarousel.addEventListener('mousedown', handleMouseDown);
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);

  // 初期化
  startAutoScroll();

  // マウスホバー時に自動スクロールを一時停止
  bannerCarousel.addEventListener('mouseenter', stopAutoScroll);
  bannerCarousel.addEventListener('mouseleave', startAutoScroll);
});
